<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable width="500">
      <v-card v-if="data">
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Detalle de Nit</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <v-card-title>
            <!-- <v-btn small outlined color="info" @click="showEdit(data)"> <v-icon class="ma-1">mdi-pencil</v-icon> Editar </v-btn> -->
            <v-spacer></v-spacer>
          </v-card-title>
          <p class="px-2" v-if="data.nombre"><strong>Nombre:</strong> {{ data.nombre }}</p>
          <p class="px-2" v-if="data.nro"><strong>Nro:</strong> {{ data.nro }}</p>
          <p class="px-2"><strong>Estado:</strong> {{ data.estado ? 'Habilitado' : 'Suspendido' }}</p>
          <p class="px-2" v-if="data.descripcion"><strong>Descripcion:</strong> {{ data.descripcion }}</p>
          <p class="px-2" v-if="data.tipo_facturacion">
            <strong>Tipo facturacion:</strong> {{ data.tipo_facturacion }}
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    props: { editedIndex: { type: Number, default: -1 } },
    data: () => ({
      data: null,
      dialog: false,
    }),

    methods: {
      showDialog(item) {
        this.dialog = true;
        this.data = item;
      },
      closeDialog() {
        this.dialog = false;
        this.data = null;
      },
      showEdit(nit) {
        this.$emit('showedit', nit, true);
        this.closeDialog();
      },
    },
  };
</script>
